import React from "react";
import "../styles/About.css";

function About() {
  return (
    <div className="about-container">
      <div className="about-header">
        <h1 className="about-title">About Hua-Shen-Herbs</h1>
        <p className="about-desc">
          At Hua-Shen-Herbs, we believe in the harmony of nature and health. Our
          mission is to bring the ancient wisdom of Traditional Chinese Medicine
          to the modern world.
        </p>
      </div>
      <div className="about-grid">
        <div className="about-card">
          <h3 className="about-card-title">Our Heritage</h3>
          <p className="about-card-desc">
            Drawing from over 3,000 years of Traditional Chinese Medicine
            wisdom, we combine ancient practices with modern quality standards.
          </p>
        </div>
        <div className="about-card">
          <h3 className="about-card-title">Our Mission</h3>
          <p className="about-card-desc">
            To restore balance and harmony in people's lives through
            personalized herbal formulations and holistic healing approaches.
          </p>
        </div>
        <div className="about-card">
          <h3 className="about-card-title">Our Promise</h3>
          <p className="about-card-desc">
            Every herb is carefully sourced and every formula is crafted with
            precision to ensure the highest quality and effectiveness.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
